module.exports = __webpack_public_path__ + "static/media/masthead-pilbara-news.01401b0b.svg";